// ============================================
// @gs/ui — Placeholder section vide
// Design System GS v1.0 — slate palette
// ============================================

import React from 'react';
import { Inbox } from 'lucide-react';

export interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export function EmptyState({ title = 'Aucune donnée', description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl
                    border-2 border-dashed border-slate-200 dark:border-slate-700
                    bg-slate-50 dark:bg-slate-800/50
                    px-6 py-12 text-center">
      <div className="mb-4 text-slate-300 dark:text-slate-600">
        {icon ?? <Inbox size={48} />}
      </div>
      <h3 className="text-base font-semibold text-slate-600 dark:text-slate-300">
        {title}
      </h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-slate-400 dark:text-slate-500">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
